import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  let navigate = useNavigate();
  const handleLogout =()=>{
    localStorage.removeItem('token');
    navigate("/login");
  }
    let location = useLocation();
   
  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            iNotebook
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className={`nav-link ${location.pathway === "/" ? "active" : ""}`} aria-current="page" to="/">
                  Home
                </Link></li>
                <li className="nav-item">
                <Link className={`nav-link ${location.pathname === "/about"? "active":""}`} aria-current="page" to="/about">
                  About
                </Link>
              </li>
            </ul>
            {!localStorage.getItem('token')? 
            <form className= "d-flex">
              <Link className= "btn btn-primary me-3" type="submit" to= "/login">LogIn</Link>
              <Link className= "btn btn-primary" to= "/signup" type="submit" >SignUp</Link>
            </form>:<button onClick={handleLogout} className="btn btn-primary">
              LogOut
            </button>
            }
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
